/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Select, Switch, Upload } from 'antd';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { CreateFormWrapper, CreateModalWrapper, ModalCloseBox } from '../employees/EmployeesStyle';
import AvatarImage from '../../components/common/AvatarImage';
import { DropdownIconNew, ModalCloseIcon } from '../../theme/SvgIcons';
import { FieldBox, FlexWrapper, PurpleText } from '../../theme/common_style';
import { clientAddApi, clientUpdateApi } from '../../services/api_collection';
import { toast } from 'react-toastify';
import uploadFileToS3, { deleteS3Object } from '../../utils/uploadS3Bucket';
import { Country, State } from 'country-state-city';
import { PhoneNumberUtil } from 'google-libphonenumber';
import {
  // capitalizeFirstLetter,
  cleanObject,
  getRegionFromDialCode
} from '../../utils/common_functions';
import { communicationOptions } from '../../utils/constant';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { useResponsiveModalWidth } from '../../hooks/useResponsiveModalWidth';
import styled from '@emotion/styled';

const { Option } = Select;

const AddClient = ({ open, onClose, editDetails, handleGetList }) => {
  const [form] = Form.useForm();
  const phoneUtil = PhoneNumberUtil.getInstance();
  const [countries, setCountries] = useState([]);
  const [contactCountryCode, setContactCountryCode] = useState(null);
  const [states, setStates] = useState([]);
  const [profileImage, setProfileImage] = useState(null);
  const image_baseurl = process.env.REACT_APP_S3_BASE_URL;
  const [loading, setLoading] = useState(false);
  const width = useResponsiveModalWidth(1000);

  const handleCreate = async () => {
    try {
      setLoading(true);
      let uploadPath;
      const values = form.getFieldsValue();
      const sourceValues = cleanObject(values?.sources) || null;
      if (profileImage && values?.profile_image) {
        const timestamp = Date.now();
        uploadPath = `clients/profileImg/${timestamp}.jpg`;
        try {
          if (editDetails?.profile_image) {
            await deleteS3Object(editDetails?.profile_image);
          }

          await uploadFileToS3(values?.profile_image, uploadPath);
        } catch (err) {
          console.error('S3 image update failed:', err);
        }
      }
      const payload = { ...values, profile_image: uploadPath, sources: sourceValues };
      let res;
      if (editDetails) {
        res = await clientUpdateApi({ ...payload, clientId: editDetails?.id });
      } else {
        res = await clientAddApi(payload);
      }
      if (res?.statusCode === 200) {
        toast.success(res?.message || 'Client added successfully');
        handleGetList();
        onClose();
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = (info) => {
    if (info.file.originFileObj) {
      setProfileImage(URL.createObjectURL(info.file.originFileObj));
      form.setFieldsValue({ profile_image: info.file.originFileObj });
    }
  };

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      toast.error('Only image files (PNG, JPEG, JPG) are allowed!');
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const handleCountryChange = (countryName, statesKey, initialCountries) => {
    setStates([]);
    form.setFieldValue(statesKey, null);
    const allCountries = countries?.length > 0 ? countries : initialCountries;
    const selectedCountry = allCountries?.find((c) => c?.name === countryName);
    if (selectedCountry) {
      const selectedStates = State.getStatesOfCountry(selectedCountry.isoCode);
      setStates(selectedStates);
    }
  };

  useEffect(() => {
    setContactCountryCode(null);
    const allCountries = Country.getAllCountries();
    setCountries(allCountries);

    if (editDetails) {
      handleCountryChange(editDetails?.country, 'state', allCountries);
      let region = getRegionFromDialCode(editDetails?.country_code + editDetails?.contact);
      setContactCountryCode({
        countryCode: region.toLocaleLowerCase(),
        dialCode: editDetails?.country_code
      });

      form.setFieldsValue({
        country: editDetails.country || undefined,
        city: editDetails.city || undefined,
        state: editDetails.state || undefined,
        name: editDetails.name || '',
        email: editDetails.email || '',
        sources: editDetails.sources || [{}],
        address: editDetails.address || '',
        contact: editDetails.contact || '',
        country_code: editDetails.country_code || '',
        contact_number: editDetails.country_code + editDetails.contact,
        client_status:
          typeof editDetails.client_status === 'boolean' ? editDetails.client_status : false
      });
    } else {
      form.resetFields();
      setProfileImage(null);
      form.setFieldsValue({ client_status: true });
    }
  }, [editDetails]);

  return (
    <Modal
      open={open}
      maskClosable={false}
      onCancel={onClose}
      centered
      width={width}
      footer={null}
      prefixCls="create-employees"
      closeIcon={false}>
      <CreateModalWrapper>
        <ModalCloseBox onClick={onClose}>
          <ModalCloseIcon />
        </ModalCloseBox>
        <div className="title">
          <h2>{editDetails ? 'Edit' : 'Add New'} Client</h2>
        </div>

        <Form
          autoComplete="off"
          form={form}
          initialValues={{ sources: [{}] }}
          onFinish={handleCreate}>
          <CreateFormWrapper>
            <div className="upload-image">
              <AvatarImage
                style={{ width: '100px', height: '100px' }}
                image={image_baseurl + editDetails?.profile_image}
                name={false}
                preview={profileImage}
              />
              <Upload
                showUploadList={false}
                beforeUpload={beforeUpload}
                onChange={handleImageUpload}>
                <p>Upload Profile Photo</p>
                <input type="file" style={{ display: 'none' }} />
              </Upload>
              <Form.Item name="profile_image" noStyle>
                <Input type="hidden" />
              </Form.Item>
            </div>

            <GridBox cols={2}>
              <FieldBox>
                <label>
                  Name <span>*</span>
                </label>
                <Form.Item
                  name="name"
                  validateFirst={true}
                  rules={[
                    { required: true, message: 'Name is required' }
                    // {
                    //   validator: (_, value) =>
                    //     value && value.trim().length >= 2
                    //       ? Promise.resolve()
                    //       : Promise.reject(new Error('Name must be at least 2 characters'))
                    // }
                  ]}>
                  <Input prefixCls="form-input" placeholder="Enter Your Name" />
                </Form.Item>
              </FieldBox>

              <FieldBox>
                <label>
                  Email <span>*</span>
                </label>
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: 'Email is required' },
                    {
                      type: 'email',
                      message: 'Please enter a valid email!'
                    }
                  ]}>
                  <Input prefixCls="form-input" type="email" placeholder="Enter Your Email" />
                </Form.Item>
              </FieldBox>
            </GridBox>

            <GridBox cols={3}>
              <FieldBox>
                <label>
                  Country <span>*</span>
                </label>
                <Form.Item
                  name="country"
                  rules={[{ required: true, message: 'Country is required' }]}>
                  <Select
                    prefixCls="form-select"
                    showSearch
                    suffixIcon={<DropdownIconNew />}
                    onChange={(countryName) => handleCountryChange(countryName, 'state')}
                    placeholder="--Select Option--">
                    {countries?.map((item, index) => (
                      <Option key={index} value={item.name} style={{ textTransform: 'capitalize' }}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </FieldBox>
              <FieldBox>
                <label>State</label>
                <Form.Item name="state">
                  <Select
                    disabled={!states?.length}
                    prefixCls="form-select"
                    suffixIcon={<DropdownIconNew />}
                    showSearch
                    placeholder="--Select Option--">
                    {states?.map((item, index) => (
                      <Option key={index} value={item.name} style={{ textTransform: 'capitalize' }}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </FieldBox>
              <FieldBox>
                <label>City</label>
                <Form.Item
                  name="city"
                  // normalize={capitalizeFirstLetter}
                >
                  <Input prefixCls="form-input" placeholder="Enter City" />
                </Form.Item>
              </FieldBox>
            </GridBox>
            <Form.Item name="country_code" noStyle>
              <Input type="hidden" />
            </Form.Item>
            <Form.Item name="contact" noStyle>
              <Input type="hidden" />
            </Form.Item>

            <Form.Item name="profile_image" noStyle>
              <Input type="hidden" />
            </Form.Item>

            <GridBox cols={2}>
              <FieldBox>
                <label>Address</label>
                <Form.Item name="address">
                  <Input prefixCls="form-input" placeholder="Enter Your Address" />
                </Form.Item>
              </FieldBox>

              <FieldBox>
                <label>
                  Contact Number <span>*</span>
                </label>
                <Form.Item
                  name="contact_number"
                  validateFirst={true}
                  rules={[
                    { required: true, message: 'Contact Number is required' },
                    {
                      validator: (_, value) => {
                        if (!value || !contactCountryCode?.countryCode) {
                          return Promise.reject(
                            'Please select a valid country and enter phone number'
                          );
                        }

                        try {
                          const regionCode = contactCountryCode.countryCode.toUpperCase();
                          const parsedNumber = phoneUtil.parse(value, regionCode);

                          if (!phoneUtil.isValidNumberForRegion(parsedNumber, regionCode)) {
                            return Promise.reject('Invalid phone number for selected country');
                          }

                          if (regionCode === 'IN') {
                            const digitsOnly = value.replace(/\D/g, '');
                            let num = digitsOnly;
                            if (digitsOnly.startsWith('91')) {
                              num = digitsOnly.slice(2);
                            }
                            if (num.length !== 10) {
                              return Promise.reject('Invalid phone number for selected country');
                            }
                          }

                          return Promise.resolve();
                        } catch (e) {
                          return Promise.reject('Invalid phone number format');
                        }
                      }
                    }
                  ]}>
                  <PhoneInput
                    enableSearch
                    country={'us'}
                    inputStyle={{
                      width: '100%',
                      height: '56px',
                      borderRadius: '6px',
                      border: '1px solid #dcdcdc',
                      fontSize: '14px',
                      paddingLeft: '48px'
                    }}
                    buttonStyle={{
                      border: 'none',
                      background: 'transparent'
                    }}
                    placeholder="Enter Your Contact Number"
                    onChange={(phone, data) => {
                      form.setFieldValue('contact', phone?.replace(data?.dialCode, ''));
                      form.setFieldValue('country_code', data?.dialCode);
                      setContactCountryCode(data);
                    }}
                    value={form.getFieldValue('country_code') + form.getFieldValue('contact')}
                  />
                </Form.Item>
              </FieldBox>
            </GridBox>

            <Form.List name="sources">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <GridBox key={key} cols={2} style={{ position: 'relative' }}>
                      <FieldBox>
                        <label>Communication Source</label>
                        <Form.Item
                          {...restField}
                          name={[name, 'source']}
                          rules={
                            fields?.length <= 1
                              ? [
                                  ({}) => ({
                                    validator(_, value) {
                                      const idVal = form.getFieldValue([
                                        'sources',
                                        name,
                                        'source_id'
                                      ]);
                                      if (!value && idVal) {
                                        return Promise.reject(
                                          new Error('Source is required if ID is filled')
                                        );
                                      }
                                      return Promise.resolve();
                                    }
                                  })
                                ]
                              : [{ required: true, message: 'Source is required' }]
                          }>
                          <Select
                            allowClear
                            prefixCls="form-select"
                            showSearch
                            placeholder="--Select Option--">
                            {communicationOptions.map((item) => (
                              <Option
                                key={item.id}
                                value={item.value}
                                style={{ textTransform: 'capitalize' }}>
                                {item.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </FieldBox>

                      <FieldBox>
                        <label>Communication ID</label>
                        <Form.Item
                          {...restField}
                          name={[name, 'source_id']}
                          rules={
                            fields?.length <= 1
                              ? [
                                  ({}) => ({
                                    validator(_, value) {
                                      const sourceVal = form.getFieldValue([
                                        'sources',
                                        name,
                                        'source'
                                      ]);
                                      if (!value && sourceVal) {
                                        return Promise.reject(
                                          new Error('ID is required if Source is filled')
                                        );
                                      }
                                      // if (value && (value.length < 5 || value.length > 30)) {
                                      //   return Promise.reject(
                                      //     new Error('ID must be 5–30 characters')
                                      //   );
                                      // }
                                      return Promise.resolve();
                                    }
                                  })
                                ]
                              : [
                                  { required: true, message: 'ID is required' }
                                  // { min: 5, max: 30, message: 'ID must be 5–30 characters' }
                                ]
                          }>
                          <Input prefixCls="form-input" placeholder="Enter Your Communication ID" />
                        </Form.Item>
                      </FieldBox>

                      {fields?.length != 1 && (
                        <Button
                          style={{ position: 'absolute', right: '0', top: '-5px' }}
                          type="text"
                          danger
                          icon={<MinusCircleOutlined />}
                          onClick={() => remove(name)}
                        />
                      )}
                    </GridBox>
                  ))}

                  <Form.Item style={{ margin: '0px' }}>
                    <FlexWrapper justify="flex-end">
                      <PurpleText
                        style={{ cursor: 'pointer', width: 'fit-content' }}
                        onClick={() => add()}>
                        <PlusOutlined /> Add More
                      </PurpleText>
                    </FlexWrapper>
                  </Form.Item>
                </>
              )}
            </Form.List>

            {editDetails && (
              <GridBox cols={1}>
                <FieldBox>
                  <label>Status</label>
                  <Form.Item name="client_status">
                    <Switch
                      prefixCls="antdCustomSwitch"
                      checkedChildren="Active"
                      unCheckedChildren="Inactive"
                    />
                  </Form.Item>
                </FieldBox>
              </GridBox>
            )}
          </CreateFormWrapper>

          <FlexWrapper justify={'end'} gap={'10px'} style={{ marginTop: '20px' }} cursor="default">
            <Button
              loading={loading}
              onClick={form.submit}
              style={{ width: '140px' }}
              prefixCls="antCustomBtn">
              Save
            </Button>
          </FlexWrapper>
        </Form>
      </CreateModalWrapper>
    </Modal>
  );
};

export default AddClient;

const GridBox = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols}, 1fr)`};
  gap: ${({ gap }) => gap || '16px'};
  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;
